import { Injectable } from '@angular/core';
import { distinct, distinctUntilChanged, map, mergeMap } from 'rxjs';
import { QuestionAttemptRealtimeBaseService } from '../../../question-v2/question-attempt-realtime-base.service';

@Injectable()
export class QuestionAttemptRealtimeChallengeService extends QuestionAttemptRealtimeBaseService {
  protected override setupListeners() {
    return this.listenForAllAttemptsStatusChanges();
  }

  private listenForAllAttemptsStatusChanges() {
    return this.questionAttemptQuery.entities$.pipe(
      map((entities) => entities.map((entity) => entity.attempt.id)),
      distinctUntilChanged((prev, curr) => prev.length === curr.length && prev.every((id, i) => id === curr[i])),
      mergeMap((ids) => ids),
      distinct(),
      mergeMap((attemptId) => this.listenToAttemptStatusChanges(attemptId)),
    );
  }
}
